import React from 'react';
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
export default function withProps(Component, defaultProps) {
  const ComponentWithClassName = Component;
  return /*#__PURE__*/React.forwardRef(function ExtendComponent(props, ref) {
    return _jsx(ComponentWithClassName, {
      ref: ref,
      ...defaultProps,
      ...props
    });
  });
}